import { render, staticRenderFns } from "./MaterialCollapseList.vue?vue&type=template&id=bc566264&"
import script from "./MaterialCollapseList.vue?vue&type=script&lang=js&"
export * from "./MaterialCollapseList.vue?vue&type=script&lang=js&"
import style0 from "./MaterialCollapseList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports